export const SPEAKER_STATS_RELOAD_INTERVAL = 1000;
